// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3QBHe","vLegacy":"SelectSecondary_vLegacy__1oCeZ","error":"SelectSecondary_error__2SfaS","disabled":"SelectSecondary_disabled__1d9xa"};